export const getRecommendedCoursePriceLabel = (course) => {
  if ((course?.course_type || '').toLowerCase() === 'free') return 'Free';
  return course?.course_price || '0.00';
};

const toCategoryArray = (value) => {
  if (Array.isArray(value)) return value.map((item) => String(item || '').trim()).filter(Boolean);
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return [];

    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => String(item || '').trim()).filter(Boolean);
      }
    } catch (error) {
      return [trimmed];
    }

    return [trimmed];
  }

  return [];
};

export const mapRecommendedCourse = (course) => ({
  id: course.id,
  image: course.banner_image,
  title: course.course_name || 'Untitled Course',
  description: course.course_desc || 'No description provided.',
  reason: course.recommendation_reason || 'Recommended for you',
  category: toCategoryArray(course.course_categories).join(', ') || 'General',
  language: course.course_language || 'English',
  level: course.levels || 'N/A',
  tags: Array.isArray(course.tags) ? course.tags : [],
  modules: course.metadata?.totalModules || 0,
  enrolled: course.metadata?.totalUsers || 0,
  duration: course.metadata?.duration || '00:00:00',
  rating: course.total_rating || 0,
  price: getRecommendedCoursePriceLabel(course),
  course_type: course.course_type,
  currency: course.currency || 'USD',
  course_url: course.course_url || null,
  is_public: Boolean(course.is_public),
  organization_name: course.organization_name || '',
});

export const mapRecommendedCourses = (courses = []) => courses.map(mapRecommendedCourse);
